// Angular Imports
import {
	HttpEvent,
	HttpHandler,
	HttpHeaders,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http'
import { Injectable, inject, signal } from '@angular/core'
// Shared Imports
import { AuthService } from '@shared/services'
import { AuthStore } from '@shared/store'
// Thirdparty Imports
import { Observable, Subject, catchError, switchMap, throwError } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class AddTokenAndRefreshInterceptor implements HttpInterceptor {
	readonly #authStore = inject(AuthStore)
	readonly #authService = inject(AuthService)

	#refreshAccessTokenInProgress = signal<boolean>(false)
	#doSameRequestCallStack: Subject<string> = new Subject<string>()

	constructor() {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		let cloneRequest: HttpRequest<unknown> = request
		const logged = this.#authStore.logged()

		if (logged && request.headers.has('Authorization')) {
			if (
				request.method.toLowerCase() === 'get' ||
				request.method.toLowerCase() === 'post' ||
				request.method.toLowerCase() === 'put' ||
				request.method.toLowerCase() === 'delete' ||
				request.method.toLowerCase() === 'patch'
			) {
				const headers = new HttpHeaders({
					Authorization: `Bearer ${this.#authStore.accessToken()}`,
				})
				cloneRequest = request.clone({
					headers,
				})
			}
		}

		// return next.handle(cloneRequest)
		return next.handle(cloneRequest).pipe(
			catchError((error: any) => {
				// console.log('error', error)
				// error.status = 401
				if (logged && cloneRequest.headers.has('Authorization')) {
					if (error && error.status === 401) {
						return this.#handlerRefreshToken(cloneRequest, next)
					} else {
						return throwError(() => error)
					}
				} else {
					return throwError(() => error)
				}
			})
		)
	}

	#handlerRefreshToken(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (this.#refreshAccessTokenInProgress()) {
			return this.#doSameRequestCallStack.pipe(
				switchMap((newAccessToken: string) => {
					return next.handle(this.#doSameRequestWithNewAccessToken(request, newAccessToken))
				})
			)
		} else {
			this.#refreshAccessTokenInProgress.set(true)
			return this.#authService.updateAccessToken(this.#authStore.refreshToken()).pipe(
				switchMap((newAccessToken: string) => {
					this.#refreshAccessTokenInProgress.set(false)
					this.#doSameRequestCallStack.next(newAccessToken)
					return next.handle(this.#doSameRequestWithNewAccessToken(request, newAccessToken))
				})
			)
		}
	}

	#doSameRequestWithNewAccessToken(
		request: HttpRequest<any>,
		newAccessToken: string
	): HttpRequest<any> {
		const headers = new HttpHeaders({
			Authorization: `Bearer ${newAccessToken}`,
		})
		return request.clone({ headers })
	}
}
